<template>
  <v-main>
    <v-container class="my-8" style="max-width: 900px">
      <v-card elevation="3" rounded="xxl" class="pa-4 pa-sm-6">
        <v-card-title>
          <h2 class="text-h5 font-weight-bold mb-1">Privacy Policy</h2>
        </v-card-title>
        <v-card-subtitle>
          Last updated: {{ lastUpdated }}
        </v-card-subtitle>
        <v-divider class="mb-4"></v-divider>
        <v-card-text class="legal-content text-body-1">
          <p>
            <strong>Oggy Kart</strong> ("we", "our", or "us") respects your
            privacy and is committed to protecting the personal information you
            share with us. This Privacy Policy explains how we collect, use,
            disclose, and safeguard your data when you use our platform.
          </p>

          <h3>1. Information We Collect</h3>
          <ul>
            <li>
              <strong>Account information:</strong> name, email address, phone
              number, and profile details you provide during signup.
            </li>
            <li>
              <strong>Order information:</strong> delivery addresses, products
              purchased, payment status, and transaction history.
            </li>
            <li>
              <strong>Device &amp; usage data:</strong> IP address, device
              identifiers, operating system, and app usage analytics.
            </li>
            <li>
              <strong>Location data:</strong> approximate or precise location
              (when permitted) to find nearby stores and enable delivery.
            </li>
          </ul>

          <h3>2. How We Use Your Information</h3>
          <ul>
            <li>To create and manage your account.</li>
            <li>To process orders, payments, and deliveries.</li>
            <li>To provide customer support and respond to queries.</li>
            <li>To send service-related notifications and updates.</li>
            <li>To improve the platform, detect fraud, and ensure security.</li>
            <li>To comply with legal obligations.</li>
          </ul>

          <h3>3. Sharing of Information</h3>
          <p>
            We do not sell your personal data. We may share information with:
          </p>
          <ul>
            <li>Delivery partners and stores to fulfil your orders.</li>
            <li>Payment gateways to process transactions securely.</li>
            <li>
              Service providers who help operate our platform (e.g., hosting,
              analytics, messaging) under strict confidentiality.
            </li>
            <li>Authorities when required by law or to protect our rights.</li>
          </ul>

          <h3>4. Data Security</h3>
          <p>
            We implement reasonable technical and organizational measures to
            protect your personal data from unauthorized access, alteration, or
            disclosure. However, no method of transmission over the internet is
            100% secure.
          </p>

          <h3>5. Data Retention</h3>
          <p>
            We retain your information for as long as your account is active or
            as needed to provide services, comply with legal obligations,
            resolve disputes, and enforce our agreements.
          </p>

          <h3>6. Your Rights</h3>
          <ul>
            <li>Access, update, or correct your personal information.</li>
            <li>Request deletion of your account and associated data.</li>
            <li>Opt out of marketing communications at any time.</li>
          </ul>
          <p>
            To request account deletion, please visit our
            <router-link to="/account-delete-request/create">
              account deletion request page</router-link>.
          </p>

          <h3>7. Children's Privacy</h3>
          <p>
            Oggy Kart is not intended for individuals under 18. We do not
            knowingly collect personal data from children.
          </p>

          <h3>8. Third-Party Links</h3>
          <p>
            Our platform may contain links to third-party websites or services.
            We are not responsible for their privacy practices and encourage
            you to review their policies.
          </p>

          <h3>9. Changes to this Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. Any changes
            will be posted here with a revised "Last updated" date.
          </p>

          <h3>10. Contact Us</h3>
          <p>
            If you have any questions or concerns about this Privacy Policy,
            please contact us through the support section in the app.
          </p>
        </v-card-text>

        <v-card-actions class="justify-center pb-4">
          <v-btn outlined color="primary" to="/login">Back to Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "PrivacyPolicyPage",
  data() {
    return {
      lastUpdated: "April 15, 2026",
    };
  },
};
</script>

<style scoped>
.legal-content h3 {
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
.legal-content p {
  margin-bottom: 0.75rem;
  line-height: 1.7;
}
.legal-content ul {
  padding-left: 1.5rem;
  margin-bottom: 0.75rem;
}
.legal-content li {
  margin-bottom: 0.25rem;
}
</style>
